import { SynchronizationStep } from '../services/dtos/synchronization-step.dto';

export class SynchronizationCheckpoint {
  userEmail: string;
  startedAt: string;
  updatedAt: string;
  steps: SynchronizationStep[];

  constructor(data: {
    userEmail: string;
    startedAt: string;
    updatedAt: string;
    steps: SynchronizationStep[];
  }) {
    this.userEmail = data.userEmail;
    this.startedAt = data.startedAt;
    this.updatedAt = data.updatedAt;
    this.steps = data.steps;
  }
}
